import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// api
import ApiKey from '../../../Components/api/ApiKey';
import BaseApi from '../../../Components/api/BaseApi';
// components
import SmallLoading from '../../../Components/element/SmallLoading';
import CVDescription from '../../../Components/element/CVDescription';
// helpers
import { logOutIfTokenExpired, resultInfo } from '../../../Components/helpers';
// hooks
import { useWindowSize } from '../../../Hooks/use-window-size';
// mui
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Flex, Container, Spinner } from '@radix-ui/themes';

import { CvCommentStore, CvCommentView } from '../../apply-cv-comment';
import { AddToFavorites, FavoritesStore } from '../feature-add-to-favorite';

import { SendEmailStore, SendEmailView } from '../../feature-send-email';

// HERE
export const FavouriteListProfile = () => {
   const { slug } = useParams();
   const location = useLocation();
   const navigate = useNavigate();
   const { width } = useWindowSize();
   const { t } = useTranslation('global');
   const userType = Cookies.get('user_type');
   const tokenKey = Cookies.get('tokenClient');

   const [cvCommentStore] = useState(() => new CvCommentStore());
   const [sendEmailStore] = useState(() => new SendEmailStore());
   const [favoritesStore] = useState(() => new FavoritesStore());

   const [loading, setLoading] = useState(true);
   const [userData, setUserData] = useState([]);
   const [mailSent, setMailSent] = useState(false);
   const [smallLoading, setSmallLoading] = useState(false);
   const [selectedFileName, setSelectedFileName] = useState([]);
   const [errors, setErrors] = useState({ subject: '', message: '' });
   const [favouriteListProfileData, setFavouriteListProfileData] = useState(null);
   const [mailReply, setMailReply] = useState({ subject: '', message: '', emailFiles: [] });

   const queryParams = new URLSearchParams(location.search);
   const cv_id = queryParams.get('cv_id');
   const job_apply_id = queryParams.get('job_apply_id');

   const getData = async () => {
      try {
         setLoading(true);

         const response = await axios.post(
            BaseApi + `/candidates/profile/${slug}`,
            {
               cv_id,
               job_apply_id,
            },
            {
               headers: {
                  key: ApiKey,
                  token: tokenKey,
                  contentType: 'application/json',
               },
            }
         );

         setLoading(false);

         if (response.data.status === 200) {
            setFavouriteListProfileData(response.data.response);
            setUserData(response.data.response.userDetailsArray);
         } else if (response.data.status === 400) {
            navigate('/');

            Cookies.remove('fname');
            Cookies.remove('user_id');
            Cookies.remove('user_type');
            Cookies.remove('tokenClient');

            resultInfo('warning', response.data.message, t('employerFavouriteList.close'));
         } else {
            Swal.fire({
               icon: 'error',
               text: response.data.message,
               title: t('employerCreateJob.createJobFailedTitle'),
               confirmButtonText: t('employerFavouriteList.close'),
            });
         }
      } catch (error) {
         setLoading(false);

         if (
            error.message === 'Network Error' ||
            error.response.data.message === 'Token has expired'
         ) {
            navigate('/');

            logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
         }

         console.error('Could not get user data in profile page of favourite list', error);
      }
   };

   const handleChange = (e) => {
      const { name, value } = e.target;

      setMailReply((prev) => ({
         ...prev,
         [name]: value,
      }));

      setErrors((prev) => ({
         ...prev,
         [name]: '',
      }));
   };

   const handleReply = async (slug) => {
      try {
         const newErrors = {};

         if (mailReply.subject === '') {
            newErrors.subject = t('employerFavouriteListProfile.subjectRequired');
            window.scrollTo(0, 0);
         }
         if (mailReply.message === '') {
            newErrors.message = t('employerFavouriteListProfile.messageRequired');
            window.scrollTo(0, 0);
         }

         setErrors(newErrors);
         setMailSent(true);

         if (Object.keys(newErrors).length === 0) {
            const confirmationResult = await Swal.fire({
               icon: 'question',
               showCancelButton: true,
               cancelButtonText: t('employerFavouriteListProfile.no'),
               confirmButtonText: t('employerFavouriteListProfile.yes'),
               text: t('employerFavouriteListProfile.sendMailConfirmTxt'),
               title: t('employerFavouriteListProfile.sendMailConfirmTitle'),
            });

            if (confirmationResult.isConfirmed) {
               const updatedReply = {
                  ...mailReply,
                  id: favouriteListProfileData.cv.user_id,
                  selectedFileName,
               };

               const formData = new FormData();
               selectedFileName.forEach((fileName, index) => {
                  formData.append(`selectedFileNames[${index}]`, fileName);
               });

               setLoading(true);

               const response = await axios.post(
                  BaseApi + `/candidates/sendmailjobseeker/${slug}`,
                  updatedReply,
                  {
                     headers: {
                        key: ApiKey,
                        token: tokenKey,
                        contentTypy: 'application/json',
                     },
                  }
               );

               setLoading(false);
               setMailSent(false);

               if (response.data.status === 200) {
                  setMailReply({
                     ...mailReply,
                     subject: '',
                     message: '',
                  });

                  setSelectedFileName([]);

                  const fileInput = document.getElementById('formFile');

                  if (fileInput) {
                     fileInput.value = '';
                  }

                  resultInfo(
                     'success',
                     t('employerFavouriteListProfile.sendMailSuccessTitle'),
                     t('employerFavouriteListProfile.close')
                  );
               } else if (response.data.status === 400) {
                  navigate('/');

                  Cookies.remove('fname');
                  Cookies.remove('user_id');
                  Cookies.remove('user_type');
                  Cookies.remove('tokenClient');

                  resultInfo(
                     'warning',
                     response.data.message,
                     t('employerFavouriteListProfile.close')
                  );
               } else {
                  Swal.fire({
                     icon: 'error',
                     text: response.data.message,
                     confirmButtonText: t('employerFavouriteListProfile.close'),
                     title: t('employerFavouriteListProfile.sendMailFailedTitle'),
                  });
               }
            }
         }
      } catch (error) {
         setLoading(false);

         if (
            error.message === 'Network Error' ||
            error.response.data.message === 'Token has expired'
         ) {
            navigate('/');

            logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
         } else {
            Swal.fire({
               icon: 'error',
               text: t('employerFavouriteListProfile.sendMailFailedTxt'),
               confirmButtonText: t('employerFavouriteListProfile.close'),
               title: t('employerFavouriteListProfile.sendMailFailedTitle'),
            });
         }
      }
   };

   const handleDownloadResume = async () => {
      try {
         setSmallLoading(true);

         const response = await axios.post(
            BaseApi + '/download-user-pdf',
            {
               id: cv_id,
               contacts: true,
            },
            {
               responseType: 'blob',
               headers: {
                  key: ApiKey,
                  token: tokenKey,
               },
            }
         );

         setSmallLoading(false);

         const url = window.URL.createObjectURL(response.data);
         const filename = response.headers['content-disposition']
            ? response.headers['content-disposition'].split('filename=')[1]
            : 'resume-grc.pdf';

         const link = document.createElement('a');
         link.href = url;
         link.setAttribute('download', filename.replace(/['"]/g, ''));
         document.body.appendChild(link);
         link.click();
         window.URL.revokeObjectURL(url);
         document.body.removeChild(link);
      } catch (error) {
         setSmallLoading(false);

         if (error.response.status === 400) {
            resultInfo(
               'warning',
               t('jobseekerManageAlert.contactsError'),
               t('jobseekerManageAlert.close')
            );
         } else {
            resultInfo(
               'error',
               t('jobDescription.unsubscribeError'),
               t('jobseekerManageAlert.close')
            );
         }

         console.error('Cannot download resume', error);
      }
   };

   useEffect(() => {
      if (userType === 'candidate' || !tokenKey) {
         navigate('/user/employerlogin');
      } else {
         getData();

         window.scrollTo(0, 0);
      }
   }, [tokenKey, navigate, userType]); // eslint-disable-line


   useEffect(() => {
      favoritesStore.loadFavFolderList({ onError: () => {}, onSuccess: () => {} });
   }, []);

   if (loading) {
      return (
         <Container>
            <Flex justify="center" align="center" height="516px">
               <Spinner size={3}></Spinner>
            </Flex>
         </Container>
      );
   }

   return (
      <>
         {loading ? (
            <div className="loader-container" />
         ) : (
            <>
               <div className="container FavouriteListProfile editProfile">
                  <div className="container my-5 JSMyCV">
                     <div className="row">
                        <div className="col cheaps">
                           <button
                              className="btn btn-primary button2"
                              onClick={() => window.history.back()}
                           >
                              <ChevronLeftOutlinedIcon /> {width >= 768 && t('cvDescription.back')}
                           </button>

                           <SendEmailView
                              store={sendEmailStore}
                              slug={slug}
                              candidateId={favouriteListProfileData?.cv?.user_id}
                              candidateName={`${userData.first_name} ${userData?.last_name}`}
                           />

                           <AddToFavorites
                              store={favoritesStore}
                              cvId={favouriteListProfileData?.cv.id}
                              candidateId={favouriteListProfileData?.cv?.user_id}
                              disabled={favouriteListProfileData?.fav_status === 1}
                              favoriteInfo={{
                                 type: 'cv',
                                 from_cv_database: null,
                              }}
                              refetch={() => {
                                 getData();
                              }}
                           />

                           <button
                              type="button"
                              disabled={smallLoading}
                              className="btn btn-primary button1"
                              onClick={() => handleDownloadResume()}
                           >
                              <FileDownloadOutlinedIcon />{' '}
                              {width >= 768 && t('cvDescription.downloadPDF')}{' '}
                              {smallLoading && (
                                 <SmallLoading width="24px" height="24px" color="#FFFFFF" />
                              )}
                           </button>
                        </div>
                     </div>
                     <CVDescription
                        cv_id={cv_id}
                        cvDetails={userData}
                        comment={
                           <CvCommentView
                              store={cvCommentStore}
                              commentData={{
                                 id: job_apply_id,
                                 comment: favouriteListProfileData.jobApply_comment,
                                 commentDate: favouriteListProfileData.jobApply_comment_date,
                              }}
                           ></CvCommentView>
                        }
                     />
                  </div>
                  <div
                     tabIndex="-1"
                     id="ReplyModal"
                     aria-hidden="true"
                     className="modal fade"
                     aria-labelledby="exampleModalLabel"
                  >
                     <div className="modal-dialog">
                        <div className="modal-content">
                           <div className="modal-header">
                              <h1 className="modal-title fs-5" id="exampleModalLabel">
                                 {t('employerFavouriteListProfile.sendMailTo')}{' '}
                                 {userData.first_name} {userData.last_name}
                              </h1>
                              <button
                                 type="button"
                                 aria-label="Close"
                                 className="btn-close"
                                 data-bs-dismiss="modal"
                              ></button>
                           </div>
                           <div className="modal-body FLPReplyModal">
                              <div className="form-outline mb-4 mt-4 DashBoardInputBx">
                                 <label className="form-label" htmlFor="form3Example3">
                                    {t('employerFavouriteListProfile.subject')}{' '}
                                    <span className="RedStar">*</span>
                                 </label>
                                 <input
                                    type="text"
                                    id="subject"
                                    name="subject"
                                    onChange={handleChange}
                                    value={mailReply.subject}
                                    placeholder={t('employerFavouriteListProfile.subject')}
                                    className={`form-control ${errors.subject && 'input-error'}`}
                                 />
                                 {errors.subject && (
                                    <div className="text-danger">{errors.subject}</div>
                                 )}
                              </div>
                              <div className="form-outline mb-4 DashBoardInputBx">
                                 <label className="form-label" htmlFor="form3Example3">
                                    {t('employerFavouriteListProfile.message')}{' '}
                                    <span className="RedStar">*</span>
                                 </label>
                                 <textarea
                                    rows={6}
                                    id="message"
                                    name="message"
                                    onChange={handleChange}
                                    value={mailReply.message}
                                    placeholder={t('employerFavouriteListProfile.message')}
                                    className={`form-control FLPTextarea ${errors.message && 'input-error'}`}
                                 ></textarea>
                                 {errors.message && (
                                    <div className="text-danger">{errors.message}</div>
                                 )}
                              </div>
                              <button
                                 type="button"
                                 aria-label={mailSent && 'Close'}
                                 onClick={() => handleReply(slug)}
                                 className="btn btn-primary button1"
                                 data-bs-dismiss={mailSent && 'modal'}
                              >
                                 {t('employerFavouriteListProfile.submitButton')}
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </>
         )}
      </>
   );
};
